module.exports = __webpack_public_path__ + "static/media/mira-technology-park-cropped.b4487d5d.png";